var loPDocs;
var mPDocs;
var tvShared, tvPrivate, tvDCSelect, tvSharedO, tvPrivateO;
var cmShared, cmSharedEmpty, cmPrivate, cmPDocs;
var gridPDocs;
var sbPdocs;
var fcPrivate = false;
var fcCollectionId = '1';
var pDocSelectionList = '1';
var clipboardTargetPrivate = false;
var clipboardAction = '';
var clipboardList = '',
	clipboardTargetCollectionId = '';
var orderDocuments = '';
var downloadCheckTimer;
var dlRequestType = '';
var pdUploadInit = null,
	dlgPDU = null,
	pduUploadId = '',
	dlgOD = null;
var documentsInitialized = false, resizeTimer = null;

function PlaceDocOrderC(response) {
	var parts = response.split('|');
	if (parts[1] == 'ACCOUNT') {
		jQuery(dlgOD).dialog('close');
		showInfoDialogPWall('Order Placed', 'Order #' + parts[0] + ' has been placed successfully.', 'ui-icon-info');
	}
	else {
		var url = 'http://';
		if (window.location.hostname.startsWith('www.panteratools') || window.location.hostname.startsWith('planexpress'))
			url = 'https://';

		orderType = 'Download';

		url = url + window.location.hostname + '/DesktopModules/PanteraModuleGlobal/OrderPayment.aspx?oc=PROJECT_WALLA&o=' + parts[0] + '&ot=' + orderType;
		window.location.href = url;
	}
}


function GetFileCountC(response) {
	jQuery('#download-order-filecount').text(response);
	jQuery('#download-order-perfilefee').text('$' + settings.DownloadPerFileFee.toFixed(2).toString());
	var total = parseInt(response) * settings.DownloadPerFileFee;
	if (settings.DownloadMinPrice > 0 && total < settings.DownloadMinPrice)
		total = settings.DownloadMinPrice;
	if (settings.DownloadMaxPrice > 0 && total > settings.DownloadMaxPrice)
		total = settings.DownloadMaxPrice;

	jQuery('#download-order-total').text('$' + total.toFixed(2).toString());
	dlgOD = jQuery("#dialog-download-order").dialog({
		modal: true,
		resizable: true,
		title: 'Download Files',
		width: 300,
		height: 200,
		buttons: {
			'Place Order': function () {
				// place order
				PanteraScript.PanteraScriptService.CreateDownloadOrderAdmin(PJQ.app.session.id, orderDocuments, PlaceDocOrderC, onScriptError);
			},
			'Cancel': function () {
				jQuery(dlgOD).dialog('close');
			}
		}
	});
}

var currentFolderId = 0;

function HandlePDocUpload(folderId) {
	currentFolderId = folderId;
	//check if this is the root private or shared folders, and assign proper folder id
	if (currentFolderId == 1) {
		currentFolderId = project.SharedFolderId;
	}
	else if (currentFolderId == 2) {
		currentFolderId = project.PrivateFolderId;
	}
	PanteraScript.PanteraScriptService.GetNewGuid(PDUploadInitialize, onScriptError);
}

//the ftp2 module expects a function with this name if we want to do something custom on upload complete
function FileUploadCallback() {
	UploadEntriesC(null);
	jQuery('#dlg-upl').dialog('close');
}

var PDUploadEntriesCCalled = false;

function UploadEntriesC(response) {
	if (PDUploadEntriesCCalled)
		return;

	PDUploadEntriesCCalled = true;

	if (fcPrivate)
		tvPrivateInit();
	else
		tvSharedInit();
}

function PDUploadInitialize(response) {
	pduUploadId = response;
	PDUploadEntriesCCalled = false;

	jQuery('#ifUpload').attr('src', '/DesktopModules/PanteraFTP2/FileUpload.aspx?folder=' + currentFolderId + '&uid=' + pduUploadId + '&sid=' + PJQ.app.session.id);
	jQuery('#ifUpload').on('load', function () {
		jQuery('#ifUpload')[0].contentWindow.ChromeProcessTheUpload = function () {
			if (typeof window.parent.FileUploadCallback === "function") {
				window.parent.FileUploadCallback();
			}
			else {
				var theForm = window.parent.document.forms["Form"];
				if (!theForm) {
					theForm = document.fileupload;
				}
				if (!theForm.onsubmit || (theForm.onsubmit() != false)) {
					theForm.__EVENTTARGET.value = "ChangeFolder";
					theForm.__EVENTARGUMENT.value = currentFolder;
					theForm.submit();
				}
			}
		}
	});

	jQuery('#dlg-upl').dialog({
		resizable: false,
		height: 455,
		width: 650,
		modal: true,
		buttons: {}
	});
	//jQuery( '#dlg-upl' ).on( 'dialogbeforeclose', function( event, ui ) { jQuery('#ifUpload').contents().find('#btnCloseAndCancel').click(); } );
	jQuery('#dlg-upl').on('dialogclose', function (event, ui) {
		jQuery('#ifUpload').attr('src', '');
		UploadEntriesC(null);
	});
}

function SelectOrderDocs() {
	ClearValidationError('#pdo-shared-folder-label');

	if (tvSharedO)
		tvSharedO.destructor();

	tvSharedO = new dhtmlXTreeObject("pdoc-order-shared", "100%", "100%", 0);
	tvSharedO.setImagePath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxTree/imgs/");
	tvSharedO.enableMultiLineItems("300px");
	tvSharedO.enableTreeLines(false);
	tvSharedO.enableItemEditor(false);
	tvSharedO.enableCheckBoxes(1);
	tvSharedO.enableSmartCheckboxes(1);
	tvSharedO.enableThreeStateCheckboxes(1);
	tvSharedO.setDataMode('json');
	tvSharedO.loadXML("/DesktopModules/PJQProjectWallAdmin/GetSharedFolders.aspx?sessionid=" + PJQ.app.session.id + "&id=0&fc=1&x=" + (new Date).getTime() + '&projectid=' + PJQ.app.session.project.id.toString(), sodsAfterLoad);

	if (!(PJQ.app.session.get('masterUserId') === 23 && (PJQ.app.session.user == null || PJQ.app.session.user.get('userTypeId') === 2))) {
		if (tvPrivateO)
			tvPrivateO.destructor();
		tvPrivateO = new dhtmlXTreeObject("pdoc-order-private", "100%", "100%", 0);
		tvPrivateO.setImagePath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxTree/imgs/");
		tvPrivateO.enableMultiLineItems("300px");
		tvPrivateO.enableTreeLines(false);
		tvPrivateO.enableItemEditor(false);
		tvPrivateO.enableCheckBoxes(1);
		tvPrivateO.enableSmartCheckboxes(1);
		tvPrivateO.enableThreeStateCheckboxes(1);
		tvPrivateO.setDataMode('json');
		tvPrivateO.loadXML("/DesktopModules/PJQProjectWallAdmin/GetPrivateFolders.aspx?sessionid=" + PJQ.app.session.id + "&id=0&fc=1&x=" + (new Date).getTime() + '&projectid=' + PJQ.app.session.project.id.toString(), sodpAfterLoad);
		jQuery('#project-docs-order').dialog({
			modal: true,
			resizable: false,
			title: "Select Document(s) to Order",
			width: 600,
			buttons: {
				"Continue": function () {
					ClearValidationError('#pdo-shared-folder-label');

					if (tvPrivateO.getAllChecked().length == 0 && tvSharedO.getAllChecked().length == 0) {
						SetValidationError('#pdo-shared-folder-label', 'Please select at least 1 File/Folder.');
						return;
					}

					orderDocuments = tvSharedO.getAllChecked();
					if (tvPrivateO.getAllChecked().length > 0) {
						if (orderDocuments.length > 0)
							orderDocuments += ',';
						orderDocuments += tvPrivateO.getAllChecked();
					}
					$(this).dialog('close');
					GetOrderOptions();
				}
			}
		});
	}
}

function sodsAfterLoad() {
	if (tvSharedO.hasChildren('1') > 0)
		tvSharedO.openItem('1');
	else
		tvSharedO.showItemCheckbox('1', 0);
}

function sodpAfterLoad() {
	if (tvPrivateO.hasChildren('2') > 0)
		tvPrivateO.openItem('2');
	else
		tvPrivateO.showItemCheckbox('2', 0);
}

function HandlePDocDownload(entryList, isCollection, isPrivate) {
	if (settings.DisableDownload && settings.DownloadPerFileFee > 0 && (!isPrivate || !settings.IsPrivateFolderException)) {
		orderDocuments = entryList;
		PanteraScript.PanteraScriptService.GetFileCount(PJQ.app.session.id, entryList, GetFileCountC, onScriptError);
	}
	else {
		if (project != null) {
			PJQ.files.queueDownload(PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: project.ProjectId
				},
				{
					endpoint: 'attachments'
				}
			]), {entryList: entryList.split(',')});
		}
		else if (projContainer != null) {
			PJQ.files.queueDownload(PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projectcontainers',
					value: projContainer.ProjectContainerId
				},
				{
					endpoint: 'attachments'
				}
			]), {entryList: entryList.split(',')});
		}
	}
}

function gridPDocsMenuRefresh() {
	var checkedDocs = gridPDocs.getCheckedRows(0);
	if (checkedDocs.length > 0) {

		mPDocs.enableItem('share_docs');

		if (!settings.ReadOnlyDocumentsPrivate && fcPrivate) {
			mPDocs.enableListOption('file_menu', 'file_delete');
		}
		else if (!settings.ReadOnlyDocumentsPublic && !fcPrivate) {
			mPDocs.enableListOption('file_menu', 'file_delete');
		}

		mPDocs.disableListOption('file_menu', 'file_upload');
		mPDocs.disableListOption('file_menu', 'file_new');
		mPDocs.disableListOption('file_menu', 'file_attach');
		mPDocs.disableListOption('file_menu', 'file_detach');

		mPDocs.enableListOption('file_menu', 'file_prop');

		mPDocs.enableListOption('file_menu', 'file_download');
	}
	else {
		mPDocs.disableItem('share_docs');
		mPDocs.disableListOption('file_menu', 'file_delete');

		mPDocs.disableListOption('file_menu', 'file_download');
		mPDocs.disableListOption('file_menu', 'file_prop');
		mPDocs.disableListOption('file_menu', 'file_new');
		mPDocs.disableListOption('file_menu', 'file_upload');

		if (!settings.ReadOnlyDocumentsPrivate && fcPrivate) {
			mPDocs.enableListOption('file_menu', 'file_new');
			mPDocs.enableListOption('file_menu', 'file_upload');
		}
		else if (!settings.ReadOnlyDocumentsPublic && !fcPrivate) {
			mPDocs.enableListOption('file_menu', 'file_new');
			mPDocs.enableListOption('file_menu', 'file_upload');
		}

		if (fcPrivate) {
			mPDocs.disableListOption('file_menu', 'file_attach');
			mPDocs.disableListOption('file_menu', 'file_detach');

			if (itemId == '2' || itemId == '4')
				mPDocs.disableListOption('file_menu', 'file_upload');
		}
		else {
			var sharedRootId = '1';
			if (mPDocs.getListOptionSelected("pdcont_menu") != 'project_documents')
				sharedRootId = '3';
			var itemId = tvShared.getSelectedItemId();
			if (itemId == sharedRootId) {
				mPDocs.disableListOption('file_menu', 'file_attach');
				if (!settings.ReadOnlyDocumentsPublic) {
					mPDocs.enableListOption('file_menu', 'file_attach');
				}
				mPDocs.disableListOption('file_menu', 'file_upload');
				if (tvShared.hasChildren(sharedRootId))
					mPDocs.disableListOption('file_menu', 'file_new');
				else if (!settings.ReadOnlyDocumentsPublic)
					mPDocs.enableListOption('file_menu', 'file_new');
			}
			else {
				mPDocs.disableListOption('file_menu', 'file_attach');
				if (!settings.ReadOnlyDocumentsPublic) {
					mPDocs.enableListOption('file_menu', 'file_new');
				}
			}

			if (tvShared.getParentId(itemId) == sharedRootId && !settings.ReadOnlyDocumentsPublic)
				mPDocs.enableListOption('file_menu', 'file_detach');
			else
				mPDocs.disableListOption('file_menu', 'file_detach');
		}
	}

	mPDocs.setItemText('file_count', gridPDocs.getRowsNum().toString() + ' Entries');
}


function PJQProjectWallAdminProjectDocumentsInitialize() {
	let $pdc = $('#project-documents-container');
	if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.NEW_APP_PORTAL) && pjqWallContext !== 'projcontainer') {
		$('#project-documents').css('height', '95%');
		$pdc.css('height', '100%');
	}
	else {
		let parentWidth = $pdc.width(),
			parentHeight = jQuery('#pjq-main').height();
		if (parentHeight < jQuery(window).height() - 350)
			parentHeight = jQuery(window).height() - 350;
		$pdc.css('width', parentWidth + 'px');
		$pdc.css('height', parentHeight + 'px');
	}

	let cells = [{
		id: "a",
		text: "Shared Folders",
		collaspedText: "Shared Folders",
		width: 400
	}, {
		id: "b",
		text: "Folder Contents",
		header: false
	}];

	let isLakeviewSuper = (PJQ.app.session.get('masterUserId') === 23 && (PJQ.app.session.user == null || PJQ.app.session.user.get('userTypeId') === 2));
	if (!isLakeviewSuper) {
		cells.push({
			id: "c",
			text: "Private Folders",
			collaspedText: "Private Folders"
		});
	}
	var dhxLayoutData = {
		parent: "project-documents-container",
		pattern: "3J",
		cells: cells
	};
	if (null == loPDocs) {

		jQuery('#pdoc-edit-title').keyup(function (ev) {
			if (ev.keyCode != 13)
				return true;

			jQuery('button', jQuery('#project-doc-edit').parent()).last().click();
		});

		loPDocs = new dhtmlXLayoutObject(dhxLayoutData);
		jQuery('div.dhtmlxInfoButtonShowHide_ver', loPDocs.cells('c')).before("<a href='javascript:void(0)' title='Refresh' onclick='tvPrivateInit()' style='position: absolute; top: 5px; right: 22px;'><img src='/images/action_refresh.gif' alt='Refresh' /></a>");

		jQuery('div.dhtmlxInfoButtonShowHide_ver', loPDocs.cells('a')).before("<a href='javascript:void(0)' title='Refresh' onclick='tvSharedInit()' style='position: absolute; top: 5px; right: 22px;'><img src='/images/action_refresh.gif' alt='Refresh' /></a>");

		//jQuery("div[ida='dhxMainCont']",loPDocs.cells("b")).addClass('pjq-drag-drop-background');


		loPDocs.setAutoSize('b', 'b;a');

		mPDocs = loPDocs.attachToolbar();
		mPDocs.setSkin("dhx_web");
		mPDocs.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");

		var contextOpts = new Array();
		contextOpts.push(new Array('project_documents', 'obj', 'Project Files', ''));
		if (settings.IsProjContainerEnabled)
			contextOpts.push(new Array('projcontainer_documents', 'obj', settings.ProjContainerLabel + ' Files', ''));

		mPDocs.addButtonSelect("pdcont_menu", 0, "Project Files", contextOpts, null, null, false);
		mPDocs.addSeparator("pdcont_menu_sep", 1);
		mPDocs.setListOptionSelected("pdcont_menu", 'project_documents');
		if (!settings.IsProjContainerEnabled) {
			mPDocs.hideItem("pdcont_menu");
			mPDocs.hideItem("pdcont_menu_sep");
		}

		var fileOpts = new Array();
		fileOpts.push(new Array('file_new', 'obj', 'New Folder', ''));
		fileOpts.push(new Array('file_new_sep', 'sep', null, ''));
		fileOpts.push(new Array('file_attach', 'obj', 'Attach Linked Folder', ''));
		fileOpts.push(new Array('file_detach', 'obj', 'Detach Linked Folder', ''));
		fileOpts.push(new Array('file_upload', 'obj', 'Upload', ''));
		fileOpts.push(new Array('file_download', 'obj', 'Download', ''));
		fileOpts.push(new Array('file_download_sep', 'sep', null, ''));
		fileOpts.push(new Array('file_delete', 'obj', 'Delete', ''));
		fileOpts.push(new Array('file_prop', 'obj', 'Properties', ''));
		mPDocs.addButtonSelect("file_menu", 2, "File", fileOpts, null, null, false);
		mPDocs.addSeparator("file_menu_sep", 3);
		mPDocs.addButton("share_docs", 4, "Share Documents", "", "");
		mPDocs.addSeparator("share_docs_sep", 5);
		mPDocs.addSpacer("share_docs_sep");

		if (!settings.RawUploadDisable) {
			mPDocs.addSeparator("upload_revision_sep", 6);
			mPDocs.addButton("upload_revision", 7, "Upload Raw Files", "", "");
		}

		mPDocs.addSeparator("file_count_sep", 9);
		mPDocs.addText("file_count", 10, "0 Entries");

		if (pjqWallContext == 'projcontainer') {
			mPDocs.setListOptionSelected("pdcont_menu", 'projcontainer_documents');
			mPDocs.setItemText("pdcont_menu", settings.ProjContainerLabel + ' Files');
			mPDocs.disableListOption("pdcont_menu", 'project_documents');

			if (settings.RawUploadDisable || settings.ReadOnlyDocumentsPublic)
				mPDocs.disableItem("upload_revision");
		}


		mPDocs.disableListOption('file_menu', 'file_detach');
		mPDocs.disableItem('share_docs');
		mPDocs.disableListOption('file_menu', 'file_delete');

		mPDocs.disableListOption('file_menu', 'file_download');
		mPDocs.disableListOption('file_menu', 'file_prop');

		mPDocs.attachEvent("onClick", function (id) {

			if (id == 'file_new')
				HandlePDocNewFolder();
			else if (id == 'file_attach') {
				if (!fcPrivate)
					HandleAttachSharedFolder(tvShared.getSelectedItemId());
			}
			else if (id == 'file_delete')
				HandlePDocDelete(gridPDocs.getCheckedRows(0));
			else if (id == 'file_prop')
				HandlePropPDocs(gridPDocs.getCheckedRows(0));
			else if (id == 'share_docs')
				HandleShareDocs(gridPDocs.getCheckedRows(0));
			else if (id == 'file_download') {
				var list = gridPDocs.getCheckedRows(0);
				HandlePDocDownload(list, list.indexOf(',') > -1 || gridPDocs.getUserData(list, "IsCollection") == "True", fcPrivate);
			}
			else if (id == 'project_documents') {
				mPDocs.setListOptionSelected("pdcont_menu", 'project_documents');
				mPDocs.setItemText("pdcont_menu", 'Project Files');
				tvSharedInit();
				tvPrivateInit();
			}
			else if (id == 'projcontainer_documents') {
				mPDocs.setListOptionSelected("pdcont_menu", 'projcontainer_documents');
				mPDocs.setItemText("pdcont_menu", settings.ProjContainerLabel + ' Files');
				tvSharedInit();
				tvPrivateInit();
			}
			else if (id == 'file_upload') {
				if (fcPrivate)
					HandlePDocUpload(tvPrivate.getSelectedItemId());
				else
					HandlePDocUpload(tvShared.getSelectedItemId());
			}
			else if (id == 'upload_revision') {
				RawFilesForm();
			}
		});

		cmShared = new dhtmlXMenuObject();
		cmShared.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxMenu/imgs/");

		if (!settings.ReadOnlyDocumentsPublic) {
			cmShared.addNewChild(cmShared.topId, 0, "new", "New Folder", false, "");
			cmShared.addNewChild(cmShared.topId, 1, "attach", "Attach Folder", false, "");
			cmShared.addNewChild(cmShared.topId, 2, "detach", "Detach Folder", false, "");
			cmShared.addNewChild(cmShared.topId, 3, "rename", "Rename Folder", false, "");
			cmShared.addNewChild(cmShared.topId, 4, "upload", "Upload", false, "");
		}

		cmShared.addNewChild(cmShared.topId, 5, "download", "Download", false, "");
		cmShared.addNewChild(cmShared.topId, 6, "share", "Share Documents", false, "");

		if (!settings.ReadOnlyDocumentsPublic) {
			cmShared.addNewChild(cmShared.topId, 10, "delete", "Delete", false, "");
		}
		cmShared.addNewChild(cmShared.topId, 12, "prop", "Properties", false, "");
		cmShared.renderAsContextMenu();
		cmShared.attachEvent("onClick", function (id, zoneId, casState) {
			var rId = tvShared.getSelectedItemId();
			if (id == 'new')
				HandlePDocNewFolder();
			else if (id == 'attach')
				HandleAttachSharedFolder(rId);
			else if (id == 'detach')
				HandleDetachSharedFolder(rId);
			else if (id == 'download')
				HandlePDocDownload(rId, true, false);
			else if (id == 'share')
				HandleShareDocs(rId);
			else if (id == 'delete')
				HandlePDocDelete(rId);
			else if (id == 'prop')
				HandlePropPDocs(rId);
			else if (id == 'rename')
				HandlePDocRename(rId, tvShared.getItemText(rId), true);
			else if (id == 'upload')
				HandlePDocUpload(rId);

		});

		cmSharedEmpty = new dhtmlXMenuObject();
		cmSharedEmpty.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxMenu/imgs/");
		if (!settings.ReadOnlyDocumentsPublic) {

			cmSharedEmpty.addNewChild(cmSharedEmpty.topId, 0, "new", "New Folder", false, "");
			cmSharedEmpty.addNewChild(cmSharedEmpty.topId, 2, "attach", "Attach Folder", false, "");
			cmSharedEmpty.addNewChild(cmSharedEmpty.topId, 11, "maproot", "Map Folder", false, "");
		}
		cmSharedEmpty.renderAsContextMenu();
		cmSharedEmpty.attachEvent("onClick", function (id, zoneId, casState) {
			if (id == 'new')
				HandlePDocNewFolder();
			else if (id == 'attach')
				HandleAttachSharedFolder(tvShared.getSelectedItemId());
			else if (id == 'maproot')
				HandleMapSharedFolder();
		});

		if (!isLakeviewSuper) {
			cmPDocs = new dhtmlXMenuObject();
			if (!settings.ReadOnlyDocumentsPublic && !fcPrivate)
				cmPDocs.addNewChild(cmPDocs.topId, 0, "rename", "Rename", false, "");
			if (!settings.ReadOnlyDocumentsPrivate && fcPrivate)
				cmPDocs.addNewChild(cmPDocs.topId, 0, "rename", "Rename", false, "");

			cmPDocs.renderAsContextMenu();
			cmPDocs.attachEvent("onClick", function (id, zoneId, casState) {
				var rowId = gridPDocs.getSelectedRowId();
				var isCollection = gridPDocs.getUserData(rowId, "IsCollection");
				if (id == 'rename') {
					HandlePDocRename(rowId, gridPDocs.cells(rowId, 2).getValue(), (isCollection == 'True'));
				}
			});

			gridPDocs = loPDocs.cells("b").attachGrid();
			gridPDocs.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
			gridPDocs.setHeader("#master_checkbox_pdoc,&nbsp;,Title,Size,Created");
			gridPDocs.setInitWidthsP("4,4,57,15,20");
			gridPDocs.setColAlign("center,right,left,right,left");
			gridPDocs.setColTypes("ch,ro,ed,ro,ro");
			gridPDocs.setColSorting("na,na,str,str,date");
			gridPDocs.setSkin(pjqGridTheme);
			gridPDocs.init();
			gridPDocs.enableContextMenu(cmPDocs);
			gridPDocs.enableAutoHeight(false, loPDocs.cells('b').getHeight() - jQuery("div", jQuery(sbPdocs)).height(), true);
			//gridPDocs.loadXML('/DesktopModules/PJQProjectWallAdmin/GetFolderContents.aspx?sessionid='+PJQ.app.session.id+'&id=1&x=' + (new Date).getTime(), gridPDocsLoaded);
			gridPDocs.attachEvent("onCheck", function (rId, cInd, state) {
				gridPDocsMenuRefresh();
			});

			gridPDocs.attachEvent("onBeforeDrag", function (id) {

				var idList = [];
				if (gridPDocs.getSelectedId())
					idList = gridPDocs.getSelectedId().split(',');
				else
					idList.push(id);

				var i = 0;
				for (i = 0; i < idList.length; i++) {
					if (gridPDocs.getUserData(idList[i], "IsProtected") == "True")
						return false;
				}

				return true;
			});

			gridPDocs.attachEvent("onBeforeContextMenu", function (id, ind, obj) {

				if (ShouldProtectFolders() && (folderContentsIsProtected || gridPDocs.getUserData(id, 'IsProtected') == 'True'))
					return false;

				obj.selectRowById(id);
				return true;
			});
			gridPDocs.enableDragAndDrop(true);
			gridPDocs.setDragBehavior('complex');
			gridPDocs.enableMultiselect(true);
			gridPDocs.gridToTreeElement = function (tree, treeID, gridID) {
				return gridID;
			};
			gridPDocs.rowToDragElement = function (id) {
				return this.cells(id, 2).getValue();
			}
			gridPDocs.attachEvent("onDragIn", function (dId, tId, sObj, tObj) {
				if (ShouldProtectFolders() && (folderContentsIsProtected || gridPDocs.getUserData(tId, 'IsProtected') == 'True' || gridPDocs.getUserData(dId, 'IsProtected') == 'True'))
					return false;

				if (settings.ReadOnlyDocumentsPublic && !fcPrivate)
					return false;
				if (settings.ReadOnlyDocumentsPrivate && fcPrivate)
					return false;
				if (dId == tId)
					return false;
				else if (sObj.getIndexById && (sObj.getIndexById('1') == 0 || sObj.getIndexById('2') == 0 || sObj.getIndexById('3') == 0 || sObj.getIndexById('4') == 0))
					return false;
				else if (tObj.doesRowExist && tObj.doesRowExist(tId) && tObj.getUserData(tId, 'IsCollection') == 'True')
					return true;
				else
					return false;
			});
			gridPDocs.attachEvent("onDrop", function (sId, tId, dId, sObj, tObj, sCol, tCol) {
				if (ShouldProtectFolders() && (folderContentsIsProtected || gridPDocs.getUserData(tId, 'IsProtected') == 'True' || gridPDocs.getUserData(sId, 'IsProtected') == 'True'))
					return false;

				if (settings.ReadOnlyDocumentsPublic && !fcPrivate)
					return false;
				if (settings.ReadOnlyDocumentsPrivate && fcPrivate)
					return false;
				clipboardTargetPrivate = fcPrivate;
				clipboardList = sId;
				clipboardTargetCollectionId = tId;
				HandleDragDrop();
				return false;
			});
			gridPDocs.attachEvent("onRowDblClicked", function (rId, cInd) {
				var isCollection = gridPDocs.getUserData(rId, "IsCollection");
				if (isCollection == 'True') {
					gridPDocs.clearAll();
					jQuery('#project-docs-selectall').prop('checked', false);
					if (fcPrivate) {
						tvPrivate.openItem(rId);
						tvPrivate.selectItem(rId, false);
					}
					else {
						tvShared.openItem(rId);
						tvShared.selectItem(rId, false);
					}
					gridPDocs.loadXML('/DesktopModules/PJQProjectWallAdmin/GetFolderContents.aspx?sessionid=' + PJQ.app.session.id + '&id=' + rId + '&x=' + (new Date).getTime(), gridPDocsLoaded);
				}
				else if (settings.DisableDownload && settings.DownloadPerFileFee > 0) {

					if (ShouldProtectFolders() && (folderContentsIsProtected || gridPDocs.getUserData(rId, 'IsProtected') == 'True'))
						return false;

					if (gridPDocs.cells(rId, 2).getValue().toLowerCase().endsWith(".pdf")) {
						ViewDoc(rId, fcCollectionId, settings.MasterUserId, settings.PortalId);
					}
					else {
						showInfoDialogPWall("File Not Viewable", "This file cannot be opened in the file viewer.");
					}
				}
				else if (settings.DisableDownload) {
					if (gridPDocs.cells(rId, 2).getValue().toLowerCase().endsWith(".pdf")) {
						ViewDoc(rId, fcCollectionId, settings.MasterUserId, settings.PortalId);
					}
					else {
						showInfoDialogPWall("File Not Viewable", "This file cannot be opened in the file viewer.");
					}
				}
				else {
					if (ShouldProtectFolders() && (folderContentsIsProtected || gridPDocs.getUserData(rId, 'IsProtected') == 'True'))
						return false;

					if (project != null) {
						PJQ.files.queueDownload(PJQ.helpers.urlHelpers.generateEndpoint([
							{
								endpoint: 'projects',
								value: project.ProjectId
							},
							{
								endpoint: 'attachments'
							}
						]), {entryList: [rId]});
					}
					else if (projContainer != null) {
						PJQ.files.queueDownload(PJQ.helpers.urlHelpers.generateEndpoint([
							{
								endpoint: 'projectcontainers',
								value: projContainer.ProjectContainerId
							},
							{
								endpoint: 'attachments'
							}
						]), {entryList: [rId]});
					}
				}
			});

			cmPrivate = new dhtmlXMenuObject();
			cmPrivate.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxMenu/imgs/");

			if (!settings.ReadOnlyDocumentsPrivate) {
				cmPrivate.addNewChild(cmPrivate.topId, 0, "new", "New Folder", false, "");
				cmPrivate.addNewChild(cmPrivate.topId, 1, "rename", "Rename Folder", false, "");
				cmPrivate.addNewChild(cmPrivate.topId, 2, "upload", "Upload", false, "");
			}
			cmPrivate.addNewChild(cmPrivate.topId, 3, "download", "Download", false, "");
			cmPrivate.addNewChild(cmPrivate.topId, 4, "share", "Share Documents", false, "");

			if (!settings.ReadOnlyDocumentsPrivate)
				cmPrivate.addNewChild(cmPrivate.topId, 7, "delete", "Delete", false, "");

			cmPrivate.addNewChild(cmPrivate.topId, 8, "prop", "Properties", false, "");
			cmPrivate.renderAsContextMenu();
			cmPrivate.attachEvent("onClick", function (id, zoneId, casState) {
				var rId = tvPrivate.getSelectedItemId();
				if (id == 'new')
					HandlePDocNewFolder();
				else if (id == 'download')
					HandlePDocDownload(rId, true, true);
				else if (id == 'share')
					HandleShareDocs(rId);
				else if (id == 'delete')
					HandlePDocDelete(rId);
				else if (id == 'prop')
					HandlePropPDocs(rId);
				else if (id == 'rename')
					HandlePDocRename(rId, tvPrivate.getItemText(rId), true);
				else if (id == 'upload')
					HandlePDocUpload(rId);
			});

			tvPrivateInit();
		}
		else {
			$('.dhtmlxInfoBarLabel:contains("c")').addClass('hidden');
		}

		tvSharedInit();

		sbPdocs = loPDocs.cells("b").attachStatusBar();

		dhtmlxEvent(window, "resize", function () {
			jQuery('#project-documents-container').css('width', '97%');
			jQuery('#project-documents-container').css('min-height', '100%');
			//PJQProjectWallAdminProjectDocumentsInitialize(); 
		});
	}

	loPDocs.setSizes();
	jQuery("div.dhxcont_global_content_area", jQuery(loPDocs.cells("c"))).children().first().children().first().css('background-color', '#FFA');

	if (project != null && project.ProjectStatus == "BUSY" && !settings.IsDocumentClerk) {
		var msg = "<div class='ui-state-highlight ui-corner-all pjq-notice'><p><span class='ui-icon ui-icon-alert'></span><strong>Note:</strong>&nbsp;This project is currently undergoing maintenance.  Documents are not available for download.'</p></div>";
		jQuery('#project-documents').prepend(msg);
		CreateRequiredOverlay();
	}
}

function CreateRequiredOverlay() {
	var newDiv = "<div id='tabDocuments_RR' class='pjq-front ui-widget-overlay'>&nbsp;</div>";
	jQuery('#tabDocuments').append(newDiv);

	jQuery(window).resize(function () {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(PJQPositionDocumentOverlays, 100);
	}).resize();
}

function PJQPositionDocumentOverlays() {
	if (project.MasterUserId == 119520) {
		jQuery('#tabDocuments_RR').remove();
		return;
	}

	var $srcElem = jQuery('#project-documents-container');
	var srcPos = $srcElem.position();
	jQuery('#tabDocuments_RR').css('position', 'absolute');
	jQuery('#tabDocuments_RR').css('top', srcPos.top + 'px');
	jQuery('#tabDocuments_RR').css('left', srcPos.left + 'px');
	jQuery('#tabDocuments_RR').css('width', '99%');
	//jQuery('#tabDocuments_RR').css('width', $srcElem.width() + 'px');
	jQuery('#tabDocuments_RR').css('height', $srcElem.innerHeight() + 'px');
}

function tvPrivateInit() {
	if ((PJQ.app.session.get('masterUserId') === 23 && (PJQ.app.session.user == null || PJQ.app.session.user.get('userTypeId') === 2))) {
		return;
	}

	tvPrivate = loPDocs.cells("c").attachTree();
	tvPrivate.setImagePath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxTree/imgs/");
	tvPrivate.enableMultiLineItems("300px");
	tvPrivate.enableTreeLines(false);
	tvPrivate.enableContextMenu(cmPrivate);
	tvPrivate.enableItemEditor(false);
	tvPrivate.enableDragAndDrop(true);
	tvPrivate.setDragBehavior('child');
	tvPrivate.setDataMode('json');

	if (mPDocs.getListOptionSelected("pdcont_menu") == 'project_documents')
		tvPrivate.loadXML("/DesktopModules/PJQProjectWallAdmin/GetPrivateFolders.aspx?sessionid=" + PJQ.app.session.id + "&id=0&fc=0&x=" + (new Date).getTime() + '&projectid=' + PJQ.app.session.project.id.toString(), tpfAfterLoad);
	else
		tvPrivate.loadXML("/DesktopModules/PJQProjectWallAdmin/GetPrivateFolders.aspx?sessionid=" + PJQ.app.session.id + "&id=4&fc=0&x=" + (new Date).getTime() + '&projectid=0', tpfAfterLoad);

	tvPrivate.attachEvent("onBeforeDrag", function (sId) {
		if (ShouldProtectFolders() && (tvPrivate.getUserData(sId, 'IsProtected') == 'True'))
			return false;
		else
			return true;
	});

	tvPrivate.attachEvent("onDragIn", function (dId, lId, sObject, tObject) {
		if (dId || lId) {
			if (ShouldProtectFolders() && (tvPrivate.getUserData(dId, 'IsProtected') == 'True') || (tvPrivate.getUserData(lId, 'IsProtected') == 'True'))
				return false;
		}

		if (sObject && sObject.getSelectedId && sObject.getSelectedId().indexOf(lId) != -1)
			return false;
		if (lId == '2' || lId == '4')
			return false;
		else
			return true;
	});
	tvPrivate.attachEvent("onDrop", function (sId, tId, id, sObject, tObject) {

		clipboardList = sId;
		if (sObject == gridPDocs)
			clipboardList = gridPDocs.getSelectedId();
		clipboardTargetPrivate = true;
		clipboardTargetCollectionId = tId;
		HandleDragDrop();
		return false;
	});

	tvPrivate.attachEvent("onSelect", function (id) {
		fcPrivate = true;
		fcCollectionId = id;
		var sharedItem = tvShared.getSelectedItemId();
		if (sharedItem.length > 0)
			tvShared.clearSelection(sharedItem);
		gridPDocs.clearAll();
		jQuery('#project-docs-selectall').prop('checked', false);
		gridPDocs.loadXML('/DesktopModules/PJQProjectWallAdmin/GetFolderContents.aspx?sessionid=' + PJQ.app.session.id + '&id=' + id + '&fc=0&x=' + (new Date).getTime(), gridPDocsLoaded);
	});
	tvPrivate.attachEvent("onBeforeContextMenu", function (itemId) {
		if (tvPrivate.getSelectedItemId() != itemId)
			tvPrivate.selectItem(itemId, true);

		var isProtected = (ShouldProtectFolders() && (tvPrivate.getUserData(itemId, 'IsProtected') == 'True'));

		if (itemId == '2' || itemId == '4') {

			if (!settings.ReadOnlyDocumentsPrivate) {
				if (tvPrivate.hasChildren('1'))
					cmPrivate.setItemDisabled("new");
				else
					cmPrivate.setItemEnabled("new");

				cmPrivate.setItemDisabled("delete");
				cmPrivate.setItemDisabled("rename");
				cmPrivate.setItemDisabled("upload");
			}

			// if anything in tree is protected, private root is considered protected
			var items = tvPrivate.getAllSubItems(0).split(',');
			if (ShouldProtectFolders()) {
				for (var i = 0; i < items.length; i++) {
					if (tvPrivate.getUserData(items[i], 'IsProtected') == 'True')
						isProtected = true;
				}

			}

			if (isProtected) {
				cmPrivate.setItemDisabled("download");
				cmPrivate.setItemDisabled("share");
			}
			else {
				cmPrivate.setItemEnabled("download");
				cmPrivate.setItemEnabled("share");
			}

		}
		else {


			if (!settings.ReadOnlyDocumentsPrivate && !isProtected) {
				cmPrivate.setItemEnabled("new");
				cmPrivate.setItemEnabled("delete");
				cmPrivate.setItemEnabled("rename");
				cmPrivate.setItemEnabled("upload");
				cmPrivate.setItemEnabled("download");
				cmPrivate.setItemEnabled("share");
			}
			else {
				cmPrivate.setItemDisabled("new");
				cmPrivate.setItemDisabled("delete");
				cmPrivate.setItemDisabled("rename");
				cmPrivate.setItemDisabled("upload");
				cmPrivate.setItemDisabled("download");
				cmPrivate.setItemDisabled("share");

			}
		}


		return true;
	});
	jQuery("div.dhxcont_global_content_area", jQuery(loPDocs.cells("c"))).children().first().children().first().css('background-color', '#FFA');

}

function tvSharedInit() {
	tvShared = loPDocs.cells("a").attachTree();
	tvShared.setImagePath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxTree/imgs/");
	tvShared.enableMultiLineItems("300px");
	tvShared.enableTreeLines(false);
	tvShared.enableContextMenu(cmSharedEmpty);
	tvShared.enableItemEditor(false);
	tvShared.enableDragAndDrop(true);
	tvShared.setDragBehavior('child');
	tvShared.setDataMode('json');

	if (mPDocs.getListOptionSelected("pdcont_menu") == 'project_documents')
		tvShared.loadXML("/DesktopModules/PJQProjectWallAdmin/GetSharedFolders.aspx?sessionid=" + PJQ.app.session.id + "&id=0&fc=0&x=" + (new Date).getTime() + '&projectid=' + PJQ.app.session.project.id.toString(), tsfAfterLoad);
	else {
		tvShared.loadXML("/DesktopModules/PJQProjectWallAdmin/GetSharedFolders.aspx?sessionid=" + PJQ.app.session.id + "&id=3&fc=0&x=" + (new Date).getTime() + '&projectid=0', tsfAfterLoad);
		if (settings.ProjContainerSharedCollapse)
			loPDocs.cells("a").collapse();
	}

	tvShared.attachEvent("onDragIn", function (dId, lId, sObject, tObject) {

		if (sObject && sObject.getSelectedId && sObject.getSelectedId().indexOf(lId) != -1)
			return false;
		if (lId == '1' || lId == '3')
			return false;
		else {
			return true;
		}
	});
	tvShared.attachEvent("onDrop", function (sId, tId, id, sObject, tObject) {
		clipboardList = sId;
		if (gridPDocs != null && sObject == gridPDocs)
			clipboardList = gridPDocs.getSelectedId();
		clipboardTargetPrivate = false;
		clipboardTargetCollectionId = tId;
		HandleDragDrop();
		return false;
	});
	tvShared.attachEvent("onSelect", function (id) {
		fcPrivate = false;
		fcCollectionId = id;
		if (tvPrivate != null) {
			var privateItem = tvPrivate.getSelectedItemId();
			if (privateItem.length > 0)
				tvPrivate.clearSelection(privateItem);
		}

		if (gridPDocs != null) {
			gridPDocs.clearAll();
			gridPDocs.loadXML('/DesktopModules/PJQProjectWallAdmin/GetFolderContents.aspx?sessionid=' + PJQ.app.session.id + '&id=' + id + '&x=' + (new Date).getTime(), gridPDocsLoaded);
		}
		jQuery('#project-docs-selectall').prop('checked', false);
	});
	tvShared.attachEvent("onBeforeContextMenu", function (itemId) {
		if (tvShared.getSelectedItemId() != itemId)
			tvShared.selectItem(itemId, true);


		if (itemId == '1' || itemId == '3') {

			if (!settings.ReadOnlyDocumentsPublic) {
				if (tvShared.hasChildren('1'))
					cmShared.setItemDisabled("new");
				else
					cmShared.setItemEnabled("new");

				cmShared.setItemEnabled("attach");
			}
			cmShared.setItemDisabled("delete");
			cmShared.setItemDisabled("rename");
			cmShared.setItemDisabled("upload");
		}
		else {

			if (!settings.ReadOnlyDocumentsPublic) {
				cmShared.setItemDisabled("attach");
				cmShared.setItemEnabled("new");
				cmShared.setItemEnabled("delete");
				cmShared.setItemEnabled("rename");
				cmShared.setItemEnabled("upload");
			}
		}

		if (!settings.ReadOnlyDocumentsPublic && (tvShared.getParentId(itemId) == '1' || tvShared.getParentId(itemId) == '3')) {
			cmShared.setItemEnabled("detach");
		}
		else if (!settings.ReadOnlyDocumentsPublic) {
			cmShared.setItemDisabled("detach");
		}

		return true;

	});
}

var folderContentsIsProtected = false;

function gridPDocsLoaded() {
	var folderPath = '';
	if (fcPrivate) {
		jQuery('#project-documents-container div.objbox').css('background-color', '#FFA');
		folderPath = '/Private Folders/';
	}
	else {
		jQuery('#project-documents-container div.objbox').css('background-color', '');
		var itemId = tvShared.getSelectedItemId();
		while (itemId != '1' && itemId != '3') {
			folderPath = tvShared.getItemText(itemId) + '/' + folderPath;
			itemId = tvShared.getParentId(itemId);
		}

		folderPath = '/Shared Folders/' + folderPath;

	}

	sbPdocs.setText(folderPath);

	if (ShouldProtectFolders()) {
		gridPDocs.forEachRow(function (id) {
			if (gridPDocs.getUserData(id, 'IsProtected') == 'True') {
				gridPDocs.cells(id, 0).setDisabled(true);
			}
		});

		folderContentsIsProtected = (gridPDocs.getUserData(null, 'IsProtected') == 'True');
	}
	else
		folderContentsIsProtected = false;

	gridPDocsMenuRefresh();
}

function tsfAfterLoad() {
	tvShared.closeAllItems('0');

	var sharedRootId = '1';
	if (mPDocs.getListOptionSelected("pdcont_menu") != 'project_documents')
		sharedRootId = '3';

	tvShared.openItem(sharedRootId);
	//tvShared.selectItem('1', false);

	if (tvShared.hasChildren(sharedRootId))
		tvShared.enableContextMenu(cmShared);

	if (!fcPrivate)
		tvShared.selectItem(fcCollectionId, false);

}

function tpfAfterLoad() {
	tvPrivate.openItem('root');
	if (fcPrivate)
		tvPrivate.selectItem(fcCollectionId, false);
}

function HandleDragDrop() {
	if (clipboardList.indexOf(',') > 0)
		jQuery('#project-doc-dnd-label').text('Do you want to Copy or Move these items?');
	else
		jQuery('#project-doc-dnd-label').text('Do you want to Copy or Move this item?');

	jQuery('#project-doc-dnd').dialog({
		modal: true,
		resizable: false,
		title: "Move/Copy Items",
		width: 400,
		buttons: {
			"Copy Item(s)": function () {
				fcPrivate = clipboardTargetPrivate;
				fcCollectionId = clipboardTargetCollectionId;
				PanteraScript.PanteraScriptService.CopyEntryList(PJQ.app.session.id, clipboardList, parseInt(clipboardTargetCollectionId), DragDropC, onScriptError);
				$(this).dialog('close');
			},
			"Move Item(s)": function () {
				fcPrivate = clipboardTargetPrivate;
				fcCollectionId = clipboardTargetCollectionId;
				PanteraScript.PanteraScriptService.MoveEntryList(PJQ.app.session.id, clipboardList, parseInt(clipboardTargetCollectionId), DragDropC, onScriptError);
				$(this).dialog('close');
			}

		}
	});
}

function DragDropC() {
	tvPrivateInit();
	tvSharedInit();
}

function HandleMapSharedFolder() {
	if (tvDCSelect)
		tvDCSelect.destructor();

	tvDCSelect = new dhtmlXTreeObject("dc-folder-tree", "100%", "100%", 0);
	tvDCSelect.setImagePath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxTree/imgs/");
	tvDCSelect.enableTreeLines(false);
	tvDCSelect.enableItemEditor(false);
	tvDCSelect.enableSmartXMLParsing(true); // false is used to disable
	//tvDCSelect.enableDistributedParsing(true); // false is used to disable
	tvDCSelect.setDataMode('json');
	tvDCSelect.attachEvent("onClick", function (id) {
		if (tvDCSelect.getUserData(id, 'disabled') == 'true')
			tvDCSelect.clearSelection();
	});
	var baseURL = "/DesktopModules/PJQProjectWallAdmin/GetDCFolders.aspx?sessionid=" + PJQ.app.session.id;
	tvDCSelect.setXMLAutoLoading(baseURL);
	tvDCSelect.attachEvent("onXLE", function (tree, id) {
		msfAfterLoad();
	});

	tvDCSelect.loadXML("/DesktopModules/PJQProjectWallAdmin/GetDCFolders.aspx?sessionid=" + PJQ.app.session.id + "&id=0&x=" + (new Date).getTime(), msfAfterLoad);

}

function mpsfC(response) {
	if (mPDocs.getListOptionSelected("pdcont_menu") == 'project_documents')
		showInfoDialogPWall('Shared Folder Mapped', 'The Project shared folder has been mapped to "' + response + '" - all new folders created at the root level will be created in this folder in your Document Center.', 'ui-icon-info');
	else
		showInfoDialogPWall('Shared Folder Mapped', 'The ' + settings.ProjContainerLabel + ' shared folder has been mapped to "' + response + '" - all new folders created at the root level will be created in this folder in your Document Center.', 'ui-icon-info');
}

function HandleAttachSharedFolder(targetFolderId) {
	if (tvDCSelect)
		tvDCSelect.destructor();

	tvDCSelect = new dhtmlXTreeObject("dc-folder-tree", "100%", "100%", 0);
	tvDCSelect.setImagePath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxTree/imgs/");
	tvDCSelect.enableTreeLines(false);
	tvDCSelect.enableItemEditor(false);
	tvDCSelect.enableSmartXMLParsing(true); // false is used to disable
	tvDCSelect.setDataMode('json');
	tvDCSelect.attachEvent("onClick", function (id) {
		if (tvDCSelect.getUserData(id, 'disabled') == 'true')
			tvDCSelect.clearSelection();
	});
	var baseURL = "/DesktopModules/PJQProjectWallAdmin/GetDCFolders.aspx?sessionid=" + PJQ.app.session.id;
	tvDCSelect.setXMLAutoLoading(baseURL);
	tvDCSelect.attachEvent("onXLE", function (tree, id) {
		asfAfterLoad();
	});
	tvDCSelect.loadXML("/DesktopModules/PJQProjectWallAdmin/GetDCFolders.aspx?sessionid=" + PJQ.app.session.id + "&id=0&x=" + (new Date).getTime(), asfAfterLoad);
	var dlg = jQuery("#select-dc-folder").dialog({
		modal: true,
		resizable: false,
		title: "Select Folder to Attach",
		width: 600,
		height: 700,
		buttons: {
			"Select Folder": function () {
				if (tvDCSelect.getSelectedItemId() == '') {
					showInfoDialogPWall('Attachment Error', 'Please select a folder to attach.', 'ui-icon-alert');
					return false;
				}
				else if ((tvDCSelect.getParentId(tvDCSelect.getSelectedItemId()) == '0')) {
					showInfoDialogPWall('Attachment Error', 'You cannot attach the "My FTP Site" folder.', 'ui-icon-alert');
					return false;
				}
				if (mPDocs.getListOptionSelected("pdcont_menu") == 'project_documents')
					PanteraScript.PanteraScriptService.AttachSharedFolder(PJQ.app.session.id, parseInt(tvDCSelect.getSelectedItemId()), asfC, onScriptError);
				else
					PanteraScript.PanteraScriptService.AttachProjectContainerSharedFolder(PJQ.app.session.id, parseInt(tvDCSelect.getSelectedItemId()), asfC, onScriptError);

				$(this).dialog('close');
			}
		}
	});
}

function asfC() {
	tvSharedInit();
}

function asfAfterLoad() {
	tvDCSelect.openItem(tvDCSelect.getItemIdByIndex('0', 0));
	tvDCSelect.selectItem(tvDCSelect.getItemIdByIndex('0', 0), true);

	var allItems = tvDCSelect.getAllSubItems('0').split(','),
		i = 0;
	for (i = 0; i < allItems.length; i++) {
		if (tvDCSelect.getUserData(parseInt(allItems[i]), 'disabled') == 'true')
			tvDCSelect.setItemStyle(parseInt(allItems[i]), 'color: #4D4D4D; font-style: italic; cursor: default;');
	}

}

function msfAfterLoad() {
	tvDCSelect.closeAllItems('0');
	tvDCSelect.openItem(settings.SharedFolderId.toString());
	tvDCSelect.selectItem(settings.SharedFolderId.toString(), true);
	tvDCSelect.focusItem(settings.SharedFolderId.toString());

	var allItems = tvDCSelect.getAllSubItems('0').split(','),
		i = 0;
	for (i = 0; i < allItems.length; i++) {
		if (tvDCSelect.getUserData(parseInt(allItems[i]), 'disabled') == 'true')
			tvDCSelect.setItemStyle(parseInt(allItems[i]), 'color: #4D4D4D; font-style: italic; cursor: default;');
	}

	var dlg = jQuery("#select-dc-folder").dialog({
		modal: true,
		resizable: false,
		title: "Select Shared Root Folder",
		width: 600,
		height: 700,
		buttons: {
			"Select Folder": function () {
				if (tvDCSelect.getSelectedItemId() == '') {
					showInfoDialogPWall('Attachment Error', 'Please select a folder to attach.', 'ui-icon-alert');
					return false;
				}
				else if ((tvDCSelect.getParentId(tvDCSelect.getSelectedItemId()) == '0')) {
					showInfoDialogPWall('Attachment Error', 'You cannot map the "My FTP Site" folder.', 'ui-icon-alert');
					return false;
				}

				settings.SharedFolderId = parseInt(tvDCSelect.getSelectedItemId());

				if (mPDocs.getListOptionSelected("pdcont_menu") == 'project_documents')
					PanteraScript.PanteraScriptService.MapProjectSharedFolder(PJQ.app.session.id, settings.SharedFolderId, mpsfC, onScriptError);
				else
					PanteraScript.PanteraScriptService.MapProjectContainerSharedFolder(PJQ.app.session.id, settings.SharedFolderId, mpsfC, onScriptError);

				$(this).dialog('close');
			}
		}
	});

}

function HandlePDocNewFolder() {
	ClearValidationError('#pdoc-edit-title');

	jQuery('#pdoc-edit-label').text('Folder Name:');
	jQuery('#pdoc-edit-title').val('');
	jQuery('#project-doc-edit').dialog({
		modal: true,
		resizable: false,
		title: "New Folder",
		width: 600,
		buttons: {
			"Create Folder": function () {
				jQuery('button', jQuery('#project-doc-edit')).button("option", "disabled", true);

				PanteraScript.PanteraScriptService.CreateFolder(PJQ.app.session.id, parseInt(fcCollectionId), jQuery('#pdoc-edit-title').val(), PDocNewFolderC, onScriptError);
			}
		}
	});

}

function PDocNewFolderC(response) {
	ClearValidationError('#pdoc-edit-title');
	if (response.startsWith('SUCCESS')) {
		fcCollectionId = response.split('|')[1];
		jQuery("#project-doc-edit").dialog('destroy');
		if (fcPrivate) {
			settings.PrivateFolderCount = settings.PrivateFolderCount + 1;
			tvPrivateInit();
			if (typeof PMDetachPF == 'function')
				PMDetachPF();
		}
		else
			tvSharedInit();
		return;
	}
	SetValidationError('#pdoc-edit-title', response);
	jQuery('button', jQuery('#project-doc-edit')).button("option", "disabled", false);

}

function HandlePDocRename(id, title, isCollection) {
	var what = 'File';
	if (isCollection)
		what = 'Folder';

	ClearValidationError('#pdoc-edit-title');

	jQuery('#pdoc-edit-label').text(what + ' Name:');
	jQuery('#pdoc-edit-title').val(title);
	jQuery('#project-doc-edit').dialog({
		modal: true,
		resizable: false,
		title: "Rename " + what,
		width: 600,
		buttons: {
			"Rename": function () {
				jQuery('button', jQuery('#project-doc-edit')).button("option", "disabled", true);
				PanteraScript.PanteraScriptService.RenameEntry(PJQ.app.session.id, parseInt(id), jQuery('#pdoc-edit-title').val(), PDocRenameC, onScriptError);
			}
		}
	});
}

function PDocRenameC(response) {
	ClearValidationError('#pdoc-edit-title');
	if (response == 'SUCCESS') {
		jQuery("#project-doc-edit").dialog('destroy');
		if (fcPrivate)
			tvPrivateInit();
		else
			tvSharedInit();
		return;
	}
	jQuery('button', jQuery('#project-doc-edit')).button("option", "disabled", false);

	SetValidationError('#pdoc-edit-title', response);
}

function HandleDetachSharedFolder(targetFolderId) {
	pDocSelectionList = tvShared.getSelectedItemId();
	showInfoDialogPWall('Detach Confirmation', 'Are you sure you want to detach the selected folder?', 'ui-icon-alert', 'detach-folder-pdocs');
}

function DetachSharedFolder() {
	if (mPDocs.getListOptionSelected("pdcont_menu") == 'project_documents')
		PanteraScript.PanteraScriptService.DetachSharedFolder(PJQ.app.session.id, parseInt(pDocSelectionList), asfC, onScriptError);
	else
		PanteraScript.PanteraScriptService.DetachProjectContainerSharedFolder(PJQ.app.session.id, parseInt(pDocSelectionList), asfC, onScriptError);
}

function HandlePDocDelete(entryList) {
	pDocSelectionList = entryList;
	var entryLabel = 'entry';
	if (entryList.split(',').length > 1)
		entryLabel = 'entries';

	showInfoDialogPWall('Delete Confirmation', 'Are you sure you want to PERMANENTLY delete the selected ' + entryLabel + '?  NOTE: This will be deleted from both this Project and your Document Center.', 'ui-icon-alert', 'delete-pdocs');
}

function DeletePDocs() {
	PanteraScript.PanteraScriptService.DeleteEntryList(PJQ.app.session.id, pDocSelectionList, DeletePDocsC, onScriptError);
}

function DeletePDocsC() {
	if (fcPrivate) {
		tvPrivateInit();
		settings.PrivateFolderCount = settings.PrivateFolderCount - pDocSelectionList.split(',').length;
		if (settings.PrivateFolderCount < 1) {
			jQuery('#project-message-attachments').css('width', '100%');
			jQuery('#pm-upload-files').css('width', '100%');
			jQuery('#project-message-private-folders,#attach-private-folders').addClass('pjq-hidden');
		}
	}
	else
		tvSharedInit();
}

function HandlePropPDocs(entryList) {
	PanteraScript.PanteraScriptService.PropertiesEntryList(PJQ.app.session.id, entryList, PropPDocsC, onScriptError);
}

function PropPDocsC(response) {
	var proplist = jQuery.parseJSON(response);
	jQuery('#pdoc-description').html("<span>" + proplist.Description + "</span>");
	jQuery('#pdoc-location').html("<span>" + proplist.Path + "</span>");
	jQuery('#pdoc-size').html("<span>" + proplist.SizeDescription + "</span>");
	jQuery('#pdoc-created').html("<span>" + proplist.CreatedDescription + "</span>");
	jQuery("#project-doc-properties").dialog({
		modal: true,
		resizable: false,
		width: 600,
		title: "Properties",
		buttons: {}
	});

}

function HandleShareDocs(entryList) {
	PanteraScript.PanteraScriptService.ShareEntryList(PJQ.app.session.id, entryList, ShareDocsC, onScriptError);
}

function ShareDocsC(response) {
	var sdata = jQuery.parseJSON(response);
	jQuery('#share-access-key').html("<span id='share-access-key-num'>" + sdata.AccessKey + "</span>");
	jQuery('#share-access-link').html("<a href='" + sdata.AccessKeyURL + "' target='_blank'>" + sdata.AccessKeyURL + "</a>");
	jQuery('#share-access-reference').val('');
	jQuery('#share-access-email').val('');
	ClearValidationError('#share-access-email');

	var dlg = jQuery("#project-doc-share").dialog({
		modal: true,
		resizable: false,
		width: 600,
		title: "Share Documents",
		buttons: {
			'Send Email': function () {
				ClearValidationError('#share-access-email');
				var emails = jQuery('#share-access-email').val().replace(/[;]/g, ',').replace(/[ ]/g, '').split(',');
				var emailError = false;
				for (i = 0; i < emails.length; i++) {

					if (!ValidateEmail(emails[i])) {
						SetValidationError('#share-access-email', 'Invalid Email Address(es) were entered.');
						emailError = true;
					}
				}

				if (emailError)
					return;

				PanteraScript.PanteraScriptService.SendAccessKey(PJQ.app.session.id, jQuery('#share-access-key-num').text(), jQuery('#share-access-reference').val(), jQuery('#share-access-email').val(), SendAccessKeyC, onScriptError);
			}
		}
	});
}

function SendAccessKeyC(response) {
	ClearValidationError('#share-access-email');

	if (response == 'SUCCESS') {
		jQuery("#project-doc-share").dialog('close');
		showInfoDialogPWall('Share Documents', 'Your Access Key has been sent.', 'ui-icon-info');

		return;
	}
	SetValidationError('#share-access-email', response);
}


dhtmlXGridObject.prototype._in_header_master_checkbox_pdoc = function (a, b, c) {
	a.innerHTML = c[0] + "<input type='checkbox' id='project-docs-selectall' />" + c[1];
	var d = this;
	a.getElementsByTagName("input")[0].onclick = function (a) {
		d._build_m_order();
		var c = d._m_order ? d._m_order[b] : b,
			g = this.checked ? 1 : 0;
		d.forEachRowA(function (a) {
			var b = this.cells(a, c);
			if (b.isCheckbox() && !b.isDisabled()) b.setValue(g), b.cell.wasChanged = !0;
			this.callEvent("onEditCell", [1, a, c, g]);
			this.callEvent("onCheckbox", [a, c, g])
		});

		gridPDocsMenuRefresh();

		(a || event).cancelBubble = !0;
	}
};

dhtmlXTreeObject.prototype.getItemSpan = function (a, b, c) {
	var c = !1,
		d = this._globalIdStorageFind(a);
	if (!d) return 0;
	return d.span;
};

dhtmlXTreeObject.prototype._moveNodeTo = function (a, b, c) {

	if (a.treeNod._nonTrivialNode) return a.treeNod._nonTrivialNode(this, b, c, a);
	if (this._checkPNodes(b, a)) return !1;
	var d = b.mytype ? a.treeNod.lWin != b.lWin : a.treeNod.lWin != b.treeNod.lWin;
	if (!this.callEvent("onDrag", [a.id, b.id, c ? c.id : null, a.treeNod, b.treeNod])) return !1;
	if (b.XMLload == 0 && this.XMLsource) b.XMLload = 1, this._loadDynXML(b.id);
	this.openItem(b.id);
	var e = a.treeNod,
		f = a.parentObject.childsCount,
		g = a.parentObject;

	this.callEvent("onDrop", [a.id, b.id, c ? c.id : null, e, b.treeNod]);
	return a.id;

};

dhtmlXGridObject.prototype._nonTrivialNode = function (a, c, e, d, h) {

	if (a.callEvent && !h && !a.callEvent("onDrag", [d.idd, c.id, e ? e.id : null, this, a]))
		return !1;

	for (var f = d.idd, g = f; a._idpull[g];)
		g += (new Date).getMilliseconds().toString();

	var b = this.isTreeGrid() ? this.getItemImage(f) : "";

	if (e) {
		for (i = 0; i < c.childsCount; i++)
			if (c.childNodes[i] == e)
				break;
		i != 0 ? e = c.childNodes[i - 1] : (st = "TOP", e = "")
	}

	a.callEvent && !h && a.callEvent("onDrop", [g, c.id, e ? e.id : null, this, a])

};

function ShouldProtectFolders() {
	if (!settings.IsProtectedFoldersEnabled)
		return false;

	try {
		var dateString = jQuery('#project-response-due').val();
		var timeString = " 11:59 PM";
		if (jQuery('#project-response-due-time').val())
			timeString = " " + jQuery('#project-response-due-time').val();

		var dateResponseDue = new Date(dateString + timeString);
		var dateNow = new Date();

		if (dateResponseDue.getTime() > dateNow.getTime())
			return true;

	} catch (err) {
	}

	return false;
}